import { CloudCredentialsSelectProps } from "@hightouch/formkit";
import { SharedProps } from ".";
import { useFormkitContext } from "src/formkit/components/formkit-context";
import { ProviderSection } from "src/components/sources/setup/providers";
import { Controller, useFormContext } from "react-hook-form";

export const FKCloudCredentialsSelect = ({
  provider,
  fieldKey,
}: CloudCredentialsSelectProps &
  SharedProps & {
    fieldKey?: string;
  }) => {
  const { credentialId, setCredentialId } = useFormkitContext();
  const { control } = useFormContext();

  // If fieldKey is provided, use form field w controller instead of context
  if (fieldKey) {
    return (
      <Controller
        control={control}
        name={fieldKey}
        render={({ field }) => (
          <ProviderSection
            provider={provider}
            credentialId={field.value}
            setCredentialId={field.onChange}
          />
        )}
      />
    );
  }

  return (
    <ProviderSection
      provider={provider}
      credentialId={credentialId}
      setCredentialId={setCredentialId}
    />
  );
};
